
import { Component, Prop, Vue } from 'vue-property-decorator'
import Checkbox from '~/components/common/Checkbox.vue'

@Component({
  name: 'RequirementFilterBar',
  components: {
    Checkbox
  }
})
export default class RequirementFilterBar extends Vue {
  @Prop({ type: String }) title!: string
  @Prop({ type: String }) description!: string
  @Prop({ type: Object, required: true }) filterSpec!: any
  @Prop({ required: true }) selectionOptions!: string[]
}
